import { Platform } from 'react-native';
import Constants from 'expo-constants';

type PlatformOS = 'ios' | 'android' | 'web' | 'unknown';

const platform = Constants.platform ?? {};

const platformFromReactNative = Platform?.OS;
const platformFromExpo = platform.ios
  ? 'ios'
  : platform.android
    ? 'android'
    : platform.web
      ? 'web'
      : 'unknown';

export const platformOS: PlatformOS =
  platformFromReactNative === 'ios' ||
  platformFromReactNative === 'android' ||
  platformFromReactNative === 'web'
    ? platformFromReactNative
    : platformFromExpo;

export const isWeb = platformOS === 'web';
export const isIOS = platformOS === 'ios';
export const isAndroid = platformOS === 'android';
export const isNative = platformOS === 'ios' || platformOS === 'android';
